import { useQuery } from '@tanstack/react-query'
import { ChallengeService } from '@duck/api-definitions'
import { apis } from '@/modules/apiClients'
import { useAuth } from './useAuth'
import { queryClient } from '@/modules/queryClient'

export const availableChallengesQueryKeys = {
  all: () => ['available-challenges'] as const,
  user: (isAuthenticated: boolean) => ['available-challenges', isAuthenticated] as const,
}

const fetchAvailableChallenges =
  async (): Promise<ChallengeService.ChallengesResponse> => {
    const response = await apis.challengeService.getAvailableChallenges()
    return response.data
  }

export const useAvailableChallenges = () => {
  const { isAuthenticated } = useAuth()
  const query = useQuery({
    queryKey: availableChallengesQueryKeys.user(isAuthenticated),
    queryFn: fetchAvailableChallenges,
    staleTime: 30 * 60 * 1000, // 30 minutes
  })

  return {
    challenges: query.data?.availableChallenges ?? [],
    assignments: query.data?.availableAssignments ?? [],
    count: query.data?.count ?? 0,
    isLoading: query.isPending,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
    clearAvailableChallenges: () => {
      queryClient.removeQueries({
        queryKey: availableChallengesQueryKeys.all(),
      })
    },
  }
}
